<script setup lang="ts">
import { SphField, SphFieldGroup } from '@/components/base/field/'
import type { PasswordReset } from '../types'
import { SphButton } from '@/components/base/button'
import SphInput from '@/components/base/input'
import { useI18n } from '@/composables/i18n'

const { i18n } = useI18n()

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
    passwordReset: PasswordReset
}>()
</script>

<template>
    <form
        :action="props.passwordReset.actionUrl"
        method="post"
        novalidate
    >
        <header>
            <h2>{{ i18n.t('Passwort zurücksetzen') }}</h2>
            <p>
                {{ i18n.t('Bitte geben Sie hier die E-Mail-Adresse ein, mit der Sie bei Uneto registriert sind.') }}
            </p>
        </header>

        <ul
            v-if="props.passwordReset.error"
            class="errors"
        >
            <li>{{ props.passwordReset.error }}</li>
        </ul>

        <SphFieldGroup>
            <SphField
                v-slot="field"
                :label="i18n.t('E-Mail-Adresse')"
                :placeholder="i18n.t('name@organisation.de')"
                required
            >
                <SphInput
                    name="username"
                    type="text"
                    v-bind="field"
                />
            </SphField>
        </SphFieldGroup>

        <div class="options">
            <a :href="props.passwordReset.loginUrl">
                {{ i18n.t('Zurück zum Login') }}
            </a>
        </div>

        <footer>
            <SphButton
                type="submit"
                variant="primary"
            >
                {{ i18n.t('Passwort zurücksetzen') }}
            </SphButton>
        </footer>
    </form>
</template>

<style scoped>
@reference "@/assets/styles/config.css";

form {
    @apply flex flex-col;
}

header {
    @apply mb-4;

    h2 {
        @apply text-xl font-black mb-2;
    }

    p {
        @apply text-gray-500 leading-normal font-medium;
    }
}

.errors {
    @apply flex flex-col mb-4 text-red-700 font-semibold;
}

.options {
    @apply mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 justify-between;
    color:#415F70;

    a {
        @apply block flex-none font-bold hover:underline whitespace-nowrap;
    }
}

footer {
    @apply mt-6;

    .sph-button {
        @apply w-full font-bold!;
    }
}
</style>
